import { debug } from "@glg/cm-shared-lib/browser/logging";
import { CMX } from "@glg/cm-shared-lib/browser/cmx";

const APP_NAME = 'Onboarding';

// To watch tracking data on server side in dev, look at your console running CM Shared because it is logged through there.

/**
 * Track an event to our shared tracking API.
 *
 * @param {string} actionName - event/action that happened
 * @param {object} attributes
 */
export const trackAction = (actionName, attributes = {}) => {
    debug(`trackEvent:`, actionName, attributes);

    CMX.Tracking.trackAction(actionName, {
        source: APP_NAME,
        attributes: {
          ...attributes,
          ...customAttribs
        }
    });
};

export const trackView = (route, resolvedViewName) => {
    CMX.Tracking.trackView(route, resolvedViewName, {
      source: APP_NAME,
      attributes: customAttribs
    })
}

const customAttribs = {
  cmid: 0
}
export function setCustomAttribute(key, val) {
  customAttribs[key] = val;
}